/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import {
  Box,
  Input /* The above code is a comment in JavaScript. It is not doing anything in terms of
functionality, but it is used to provide information or explanations about the
code to other developers. */,
  Typography,
} from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import Footer from "./footer";
import Dropdown from "./dropdown";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const taxAuthoritiesOption = [
  {
    value: "Cục thuế TP.HCM",
    label: "Cục thuế TP.HCM",
  },
  {
    value: "Cục thuế An giang",
    label: "Cục thuế An giang",
  },
  {
    value: "Cục thuế Cần thơ",
    label: "Cục thuế Cần thơ",
  },
  {
    value: "Cục thuế Hà nội",
    label: "Cục thuế Hà nội",
  },
];

const provinceOption = [
  {
    value: "An giang",
    label: "An giang",
  },
  {
    value: "Cần thơ",
    label: "Cần thơ",
  },
  {
    value: "TP Hồ Chí Minh",
    label: "TP Hồ Chí Minh",
  },
];

const districtOption = [
  {
    value: "Châu thành",
    label: "Châu thành",
  },
  {
    value: "Long xuyên",
    label: "Long xuyên",
  },
  {
    value: "Chợ mới",
    label: "Chợ mới",
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    taxAuthoritiesProvince: {
      type: "select",
      value: null,
      bg: false,
      option: taxAuthoritiesOption,
    },
    taxAuthoritiesDistrict: {
      type: "select",
      value: null,
      bg: false,
      option: taxAuthoritiesOption,
    },
    province: {
      type: "select",
      value: null,
      bg: false,
      option: provinceOption,
    },
    district: {
      type: "select",
      value: null,
      bg: false,
      option: districtOption,
    },
    address: {
      type: "input",
      value: null,
      bg: false,
    },
  },
];

export default function RefundTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  const addNewRow = () => {
    // const newIdValue = getMaxIdValue() + 1;
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: uuidV4(),
        bg: true,
      },
      taxAuthoritiesProvince: {
        type: "select",
        value: null,
        bg: false,
        option: taxAuthoritiesOption,
      },
      taxAuthoritiesDistrict: {
        type: "select",
        value: null,
        bg: false,
        option: taxAuthoritiesOption,
      },
      province: {
        type: "select",
        value: null,
        bg: false,
        option: provinceOption,
      },
      district: {
        type: "select",
        value: null,
        bg: false,
        option: districtOption,
      },
      address: {
        type: "input",
        value: null,
        bg: false,
      },
    };
    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Td rowSpan={3} style={{ textAlign: "center" }}>
                STT
              </Td>
              <Td colSpan={5} style={{ textAlign: "center" }}>
                Khu đất thuê
              </Td>
            </tr>
            <tr>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                CQT quản lý khu đất
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Tỉnh/Thành phố
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Quận/Huyện
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Địa chỉ
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                QT cấp cục
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                QT cấp chi cục
              </Td>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {index + 1}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.taxAuthoritiesProvince.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxAuthoritiesProvince?.type !== "select" ? (
                      row.taxAuthoritiesProvince.value
                    ) : (
                      <SelectTable
                        name="taxAuthoritiesProvince"
                        id={row.id.value}
                        option={
                          row.taxAuthoritiesProvince.option
                            ? row.taxAuthoritiesProvince.option
                            : defaultOption
                        }
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.taxAuthoritiesDistrict.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxAuthoritiesDistrict?.type !== "select" ? (
                      row.taxAuthoritiesDistrict.value
                    ) : (
                      <SelectTable
                        name="taxAuthoritiesDistrict"
                        id={row.id.value}
                        option={
                          row.taxAuthoritiesDistrict.option
                            ? row.taxAuthoritiesDistrict.option
                            : defaultOption
                        }
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.province.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.province?.type !== "select" ? (
                      row.province.value
                    ) : (
                      <SelectTable
                        name="province"
                        id={row.id.value}
                        option={row.province.option ? row.province.option : defaultOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.district.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.district?.type !== "select" ? (
                      row.district.value
                    ) : (
                      <SelectTable
                        name="district"
                        id={row.id.value}
                        option={row.district.option ? row.district.option : defaultOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.address.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.address?.type !== "input" ? (
                      row.address.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="address"
                        value={row.address.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
